export const cloudinaryPortfolioPhotos = [
  {
    publicId: "portfolio-nate-paradiso-photography/kdve5ufeal8g9hfnlepc",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/gvfafvz5g66ekj1guok1",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/x7lnbv3iwk9my9i8dmam",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/pecbcnkfejvov5jiymxk",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/hz187iezzs4cszdiraeq",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ynjdreuri0xrqllq1bz5",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/dokpv5s0okcgtbtaxusm",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/zwpkncwz9ztnrhsx1kza",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/pgsf0ivw3yigd3uzhorn",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/tjjzeofkz5qxfagrs4n0",
    width: 660,
    height: 301,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ydvg0vhjzfsix8mrcvky",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/i3gr3ghdhws3hbh4x2on",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/jhshudikqtvn3y6jiufz",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/euqkkvv5knrdsn2oqtkt",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/qm02ijfuuw6vtmixoqq9",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/bzldhr7e3vukjv94jcao",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/cx9eakkldzruv29dtgvt",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/rl4jbg7pxtjrmistqwfs",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ybsskgqfupyhgbdt9o9i",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/qcskqdjzxhjxyb84mwwx",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/gbuxi5whbpodkbverrih",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/niamjfscwma7wxvdwotu",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/c7xvjk7hikw3bzds11kw",
    width: 660,
    height: 248,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/eb5pt2yuovcucmkgivxi",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/pygwbp1x16puyiu1xzcl",
    height: 660,
    width: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/s3jbz5tngt8rl82qlevk",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/bmuzmhytnuxjm3dxgt2p",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/krpgza1unbyrozvofgqy",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/qq15m7z7urd9hzfdlkxf",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/uvmsvzm7tmvcqk4cw9mf",
    height: 660,
    width: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/qccjzf1nnqsqf7sunsev",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/xoa6tjthpqj1boytmjab",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/yuplbvkxcfieb0atzphl",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/cnreuizpuhanxa5wlu8o",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/iym3el77nkqo5ozwxi13",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ilphgec1ekocxx7bvqkl",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/i5k5ckvumcl5bkou5nn4",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/tmfytvl1u6zbsgx31jhs",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/lyuhfkaofjee7vagsqh9",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/myzxmagrwyvck3h2zhtt",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/fd5nmy9xil6mso9xvjhc",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/dh3rphppklqpqgbp1izs",
    height: 660,
    width: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/g07rnv8qwjgs2cd7lbvv",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/hmg40zw11ww36dpkpsbl",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/xytuyguvo3hymu3huuus",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/tw4e2xdtr5bjj2jnvsjc",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/xaimixlxm161qnffk45j",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ulk5n853nflir71iyeen",
    height: 660,
    width: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/eyrr2h3psmwr6q9f17z7",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/ubyfnlk2bgru5qvaej4y",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/jzztvwlfb7ah9lmreile",
    width: 660,
    height: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/kdvnpeburwpnqxbhorki",
    height: 660,
    width: 441,
  },
  {
    publicId: "portfolio-nate-paradiso-photography/a3ig1ex3arb7swjzldvn",
    width: 660,
    height: 441,
  },
];
